// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__61fEG","right":"styles_right__1l0bF"};